import { BASE } from "./api";

// Stored upload paths come in two shapes: "jf-123.pdf" and "/uploads/jf-123.pdf"
// (older routes saved the second form). Accept both, so a file is never requested
// as /uploads//uploads/... Full http(s) URLs are returned unchanged.
export function uploadUrl(p) {
  if (!p) return "";
  const s = String(p);
  if (/^https?:/.test(s)) return s;
  return BASE + "/uploads/" + s.replace(/^\/*(uploads\/)?/, "");
}
